import { render, staticRenderFns } from "./blufreccia.vue?vue&type=template&id=bcbe1474&"
import script from "./blufreccia.vue?vue&type=script&lang=js&"
export * from "./blufreccia.vue?vue&type=script&lang=js&"
import style0 from "./blufreccia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports